import DrNodeTagDrawer from './DrNodeTagDrawer.component';

export default DrNodeTagDrawer;